import { gql } from '@apollo/client';

export const DriveFacetFragment = gql`
  fragment DriveFacetFragment on Facets {
    drive {
      gearBox {
        name
        displayName
      }
      power {
        key
        min
        max
      }
      maxCubicCapacity
    }
  }
`;
